import PortalIdParser from 'PortalIdParser';
export const SELECTED_BUSINESS_UNIT_LOCAL_STORAGE_KEY = 'SELECTED_BUSINESS_UNIT';
export const ACCOUNT_BUSINESS_UNIT_ID = 0;
export const ALL_BUSINESS_UNITS_VALUE = 'ALL';
export const getCurrentBusinessUnit = () => {
  const PORTAL_ID = PortalIdParser.get();
  let localStorageValue = '0';
  let parsedBU = {};
  try {
    localStorageValue = window.localStorage.getItem(SELECTED_BUSINESS_UNIT_LOCAL_STORAGE_KEY) || '{}';
  } catch (e) {
    localStorageValue = '{}';
  }
  try {
    parsedBU = localStorageValue ? JSON.parse(localStorageValue) : 0;
  } catch (e) {
    parsedBU = {};
  }
  try {
    if (typeof parsedBU === 'object' && PORTAL_ID !== undefined) {
      return Number(parsedBU[PORTAL_ID]) || 0;
    } else {
      const sanitisedBU = String(parsedBU).replace(/^"|"$/g, '');
      return sanitisedBU === ALL_BUSINESS_UNITS_VALUE ? Number(sanitisedBU) : parseInt(String(parsedBU), 10);
    }
  } catch (e) {
    return 0;
  }
};
export default getCurrentBusinessUnit;